export default "__VITE_ASSET__3jYMQIqA__"